import * as React from 'react';

import * as Leads from 'nutshell-core/leads';

import {Button} from 'shells/button/button';
import {ErrorDialog} from 'shells/dialog/error-dialog';

import type {Lead_stageset} from 'nutshell-graphql-types';

import {useGetStagesets} from '../../../core/select/hooks/use-get-stagesets';

import {PipelineSelectPopover} from '../../shared/components';

type Props = {
    leadId: string;
    stageset: Lead_stageset;
    onlyShowButton?: boolean;
};

export function LeadChangePipeline(props: Props) {
    const {onlyShowButton = false} = props;

    const {stagesets, isLoading} = useGetStagesets();
    const pipelineRef = React.useRef(null);
    const [isPipelineSelectorVisible, setIsPipelineSelectorVisible] =
        React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string | null | undefined>(null);

    // We could also get an error state in here, but I'm not sure
    // it's worth the complexity.
    if (isLoading || stagesets.length <= 1) {
        return <span>Pipeline: {props.stageset.name}</span>;
    }

    const handleChangeStageset = (leadId: string, stagesetId: string) => {
        return Leads.changeStageset(leadId, stagesetId)
            .then(() => {
                setIsPipelineSelectorVisible(false);
                document.location.reload();
            })
            .catch((response) => {
                const parsedResponse = JSON.parse(response.responseText);
                let responseError =
                    parsedResponse && parsedResponse.errors ? parsedResponse.errors[0].title : null;

                if (responseError === null && parsedResponse.message) {
                    responseError = parsedResponse.message;
                }

                setIsPipelineSelectorVisible(false);
                setErrorMessage(responseError);
            });
    };

    return (
        <span>
            {!onlyShowButton && <span>Pipeline:&nbsp;</span>}
            <Button
                getButtonRef={pipelineRef}
                noPadding={true}
                onClick={() => setIsPipelineSelectorVisible(true)}
                variant='text-primary'
            >
                {props.stageset.name}
            </Button>
            {isPipelineSelectorVisible ? (
                <PipelineSelectPopover
                    selectedStagesetId={props.stageset.id}
                    onChangeStageset={(stagesetId: string) =>
                        handleChangeStageset(props.leadId, stagesetId)
                    }
                    onClose={() => setIsPipelineSelectorVisible(false)}
                    anchor={pipelineRef.current}
                />
            ) : undefined}
            {errorMessage ? (
                <ErrorDialog
                    anchor={pipelineRef.current}
                    location='bottom'
                    message={`There was a problem changing the pipeline on this lead${
                        errorMessage ? ` (${errorMessage})` : ''
                    }`}
                    onClose={() => setErrorMessage(null)}
                />
            ) : null}
        </span>
    );
}
